<template>
  <div class="rew19_aro_wrap shop">

    <div v-show="!showAroResult" class="rew19_basketList_wrap rew19_basketBottom">
      <h2>
        <span class="rew19_basketList_tit">결제하기</span>
      </h2>
      <div class="rew19_paymentList">
        <dl class="rew19_paymentGroup">
          <dt class="rew19_paymentDt rew19_on">
            <div class="rew19_inBt">주문 상품 내역</div>
            <button type="button" class="rew19_opBt">
              <span>열림</span>
            </button>
          </dt>
          <dd class="rew19_payment_container product_layout">
             <order-product-list ref="orderProductList" :mode="mode" @setData="setTotalPrice"/>
          </dd>

          <dt class="rew19_paymentDt" v-if="mode != 'NTC'">
            <div class="rew19_inBt" v-if="paymentCase=='1'">수령희망일 (두번째 달부터 적용)</div>
            <div class="rew19_inBt" v-if="paymentCase!='1'">자동 결제일 (두번째 달부터 적용)</div>
          </dt>
          <dd class="rew19_payment_container" v-if="mode != 'NTC'">
            <wish-delivery ref="wishDelivery" :mode="mode" :paymentCase="paymentCase" @changed="onChangeWishDeliveryDate"/>
          </dd>

          <dt class="rew19_paymentDt" v-if="mode == 'NTC'">
            <div class="rew19_inBt">결제일</div>
          </dt>
          <dd class="rew19_payment_container" v-if="mode == 'NTC'">
            <wish-payment ref="wishPayment" :mode="mode"/>
          </dd>

          <dt class="rew19_paymentDt" v-if="mode != 'NTC'">
            <div class="rew19_inBt">배송정보</div>

            <a @click="openChangeShipInfoDialog" class="rew19_rpBt rew19_btn_T1 delivery">
              <span>변경</span>
            </a>
          </dt>

          <dd class="rew19_payment_container" v-if="mode != 'NTC'">
            <ul class="rew19_variableline">
                <li class="line2">
                    <em>{{shipInfoDialog.shipName}}</em>
                    <span>{{shipInfoDialog.phoneNumber}}</span>
                </li>
                <li class="line1">
                    {{shipInfoDialog.firstAddress + shipInfoDialog.lastAddress}}
                </li>
            </ul>
          </dd>

          <dd class="rew19_payment_contents_container" v-if="mode != 'NTC' && isShowContents">
            <ul class="rew19_payment_productDl">
              {{contentMessage}}
            </ul>
            <div class="rew19_clear" v-if="isShowDeliveryBtn == 'Y'">
              <button type="button" class="rew19_btnDetail">
                <span><a v-bind:href="contentsUrl" target="_blank">{{btnTitle}}</a></span>
              </button>
            </div>
          </dd>

          <dt class="rew19_paymentDt solidinform" v-if="mode != 'NTC'">
            <div class="rew19_inBt">정기구매 주문 명칭</div>
            <div class="rew19_form_full">
              <input
                v-model.trim="params.aroTag"
                title="정기구매 주문 명칭"
                type="text"
                class="autoFocus rew19_inputTxt_t1"
                value=""
              />
            </div>
          </dt>
          <dt class="rew19_paymentDt" v-if="mode != 'NTC'">
            <div class="rew19_inBt">제품명세 및 수령증</div>
          </dt>
          <dd class="rew19_payment_container" v-if="mode != 'NTC'">
            <receipt ref="receipt" />
          </dd>

          <dt class="rew19_paymentDt">
            <div class="rew19_inBt">전자 거래명세서 수신</div>
          </dt>
          <dd class="rew19_payment_container">
            <electronic-statement ref="ElectronicStatement" />
          </dd>

          <dt class="rew19_paymentDt rew19_viewOp">
            <div class="rew19_inBt">최종 결제 금액</div>
          </dt>
          <dd class="rew19_payment_container rew19_viewOp">
            <ul class="rew19_payList">
              <li>
                <em class="rew19_payTitle">결제금액</em>
                <span class="rew19_payinputSt disp_payment_amt">
                  <strong>{{$fmt.WON(total_price.payment_amt)}}</strong>원
                </span>
              </li>
              <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                <em class="rew19_payTitle">합계SV</em>
                <span class="rew19_payinputSt disp_sv">{{$fmt.PV(total_price.total_pv)}}</span>
              </li>
              <li v-if="getMemberType() == 'DIST'">
                <em class="rew19_payTitle">합계CSV</em>
                <span class="rew19_payinputSt disp_cv">{{$fmt.PV(total_price.total_cv)}}</span>
              </li>
<!--              <li v-if="isShowTotalSb">-->
<!--                <em class="rew19_payTitle">합계SB</em>-->
<!--                <span class="rew19_payinputSt disp_cv">{{$fmt.PV(total_price.total_sb)}}</span>-->
<!--              </li>-->
            </ul>
          </dd>

          <dt class="rew19_paymentDt">
            <div class="rew19_inBt">{{paymentMethodChange}}</div>
          </dt>
          <dd :class="['rew19_payment_container', isHidden ? '' : 'rew19_payment_lineup']">
<!--          <dd class="rew19_payment_container">-->
            <payment-method
              ref="paymentMethod"
              :mode="mode"
              :paymentMode="paymentMode"
              :isHidden="isHidden"
              @getData="getPaymentData"
              @setTerms="setTerms"/>
          </dd>

          <dt class="rew19_paymentDt">
            <div class="rew19_inBt">정기구매 약관 동의</div>
          </dt>
          <dd class="rew19_payment_container">
            <terms ref="terms" :mode="mode" :paymentMode="paymentMode"/>
          </dd>
        </dl>
      </div>
      <!--//rew19_basketList-->
    </div>

    <div v-show="!showAroResult" class="rew19_basketList_fixed rew19_payment">
      <div class="rew19_basketItems_wrap">
        <h3 class="rew19_ptMiddle">
          <em>최종 결제금액</em>
        </h3>
        <p v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'" class="rew19_basketPrice">
          <em>합계 SV</em>
          <span>{{$fmt.PV(total_price.total_pv)}}</span>
        </p>

        <p v-if="getMemberType() == 'DIST'" class="rew19_basketPrice">
          <em>합계 CSV</em>
          <span class="disp_sv">{{$fmt.PV(total_price.total_cv)}}</span>
        </p>

<!--        <p v-if="isShowTotalSb" class="rew19_basketPrice">-->
<!--          <em>합계 SB</em>-->
<!--          <span class="disp_cv">{{$fmt.PV(total_price.total_sb)}}</span>-->
<!--        </p>-->

        <p class="rew19_basketPrice sum">
          <em>결제 금액</em>
          <span>
            <strong class="disp_payment_amt">{{$fmt.WON(total_price.payment_amt)}}</strong>원
          </span>
        </p>
      </div>
      <a @click="validationPaymentData" class="rew19_basket goPay" onclick="return false;">
        <span>결제하기</span>
      </a>
    </div>

    <ship-info-dialog
      :show="shipInfoDialogShow"
      @close="changeShipInfo"
      ref="shipInfoDialog"
    ></ship-info-dialog>

    <aro-result
      ref="paymentResult"
      v-if="showAroResult"
      :mode="mode" :paymentCase="paymentCase"
      ></aro-result>
  </div>
  <!--rew19_aro_wrap-->
</template>
<script>
import AroBase from '@/components/base/AroBase';
import { mapMutations, mapState } from "vuex";
import OrderProductList from "@/components/payment/OrderProductList";
import WishDelivery from "@/components/payment/WishDelivery";
import WishPayment from "@/components/payment/WishPayment";
import Receipt from "@/components/payment/Receipt";
import ElectronicStatement from "@/components/payment/ElectronicStatement";
import PaymentMethod from "@/components/payment/PaymentMethod";
import Terms from "@/components/payment/Terms";
import ShipInfoDialog from '@/components/popup/ShipInfoDialog';
import AroResult from "./result";

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "AroPayment",
  extends: AroBase,
  components: {
    OrderProductList,
    WishDelivery,
    WishPayment,
    Receipt,
    ElectronicStatement,
    PaymentMethod,
    Terms,
    ShipInfoDialog,
    AroResult
  },
  props: {
    mode: {
      type: String,
      default : "" //
    },
    uspan_yn: {
      type: String,
      default : "" //
    },
    uspancode: {
      type: String,
      default : "" //
    },
  },
  computed: {
    ...mapState("app", [
      "aroApplyResult",
      "aroNtcApplyResult",
      "memberBirthDt"
    ]),
    aroApplyResult: {
      get() {
        return this.$store.state.app.aroApplyResult;
      },
      set(val) {
        this.setAroApplyResult(val);
      }
    },
    aroNtcApplyResult: {
      get() {
        return this.$store.state.app.aroNtcApplyResult;
      },
      set(val) {
        this.setAroNtcApplyResult(val);
      }
    },
    memberBirthDt: {
      get() {
        return this.$store.state.app.memberBirthDt;
      },
      set(val) {
        this.setMemberBirthDt(val);
      }
    }
  },
  data: () => ({
    //View Data
    params: {
      member_name: "",
      ship_name: "",
      ship_tel: "",
      ship_phone: "",
      postal_cd: "",
      home_addr: "",
      home_addr_detail: "",
      delivery_day: "",
      payment_day: "",
      payment_amt: "",
      wholesale_receipt: "",
      e_transaction_type: "",
      payment_typ: "",
      aroTag: "", //정기 구매 명칭
      now: 0,
      paymentMethodChange: "결제수단",
      isHidden: false
    },

    paymentMode: 0,

    total_price: {
      payment_amt: "0",
      total_pv: "0",
      total_cv: "0",
      // total_sb: "0"
    },

    basket: [],

    memberInfo: {},

    //배송지 변경
    shipInfoDialogShow : false,
    shipInfoDialog : {},

    showAroResult : false,
    // isShowTotalSb : false,

    //안내 컨텐츠
    isShowContents : false,
    contentsUrl : "",
    contentMessage : "",
    isShowDeliveryBtn : "",
    btnTitle: "",

    paymentCase : "",
  }),
  created() {},

  mounted() {
    let _this = this;

    switch(_this.mode){
    case Const.ARO_BASKET_MODE:
    case Const.ARO_15_BASKET_MODE:
      _this.paymentMode = 0;
      break;
    case Const.ARO_NTC_BASKET_MODE:
      _this.paymentMode = 2;
      break;
    }

    this.updateNow()
    setInterval(this.updateNow.bind(this) , 1000)

    _this.initUi();
    _this.getMemberInfo();

    //  if(_this.getMemberType() == "DIST" && _this.getMemberTitle() >= 40){
    //   _this.isShowTotalSb = true;
    // }
  },

  methods: {

    updateNow() {
      const now = new Date();
      let ckTime = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;

      if(this.$december1st <= parseInt(ckTime)){
        this.paymentMethodChange = "결제정보";
        this.isHidden = true;//숨겨짐
      }else{
        this.paymentMethodChange = "결제수단";
        this.isHidden = false;
      }
      this.$refs.paymentMethod.updateVisibility(this.isHidden);
    },

    ...mapMutations("app", [
            "setAroApplyResult",
            "setAroNtcApplyResult",
            "setMemberBirthDt"
            ]),
    initUi(){
      $(".rew19_btnDetail").on("click",(e) => { // 결제 자세히보기
        if ($(e.currentTarget).parent().next().hasClass("rew19_paymentDon")) {
          $(e.currentTarget).parent().next().show();
          $(e.currentTarget).parent().addClass("rew19_on");
          $(e.currentTarget).parent().next().removeClass("rew19_paymentDon");
        } else {
          $(e.currentTarget).parent().next().hide();
          $(e.currentTarget).parent().removeClass("rew19_on");
          $(e.currentTarget).parent().next().addClass("rew19_paymentDon");
        }
      });

      $(".rew19_paymentDt .rew19_opBt").off();
      $(".rew19_paymentDt .rew19_opBt").click(function(){ // 결제하기 주문상품내역
        if ($(this).parent(".rew19_paymentDt").next().hasClass("rew19_payment_oc")) {
          $(this).parent(".rew19_paymentDt").next().removeClass("rew19_payment_oc");
          $(this).parent(".rew19_paymentDt").next().show();
          $(this).parent(".rew19_paymentDt").addClass("rew19_on");
        } else {
          $(this).parent(".rew19_paymentDt").next().addClass("rew19_payment_oc");
          $(this).parent(".rew19_paymentDt").next().hide();
          $(this).parent(".rew19_paymentDt").removeClass("rew19_on");
        };
    	});
    },
    apiGetMmemberDetail(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_member_detail`, {});
    },
    apiOrderAro(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/order_aro`, {
        params: {..._this.params}
      });
    },
    apiOrderNtc(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/order_ntc`, {
        params: {..._this.params}
      });
    },
    apiGetNtc(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_ntc`, {});
    },
    apiTagValidation(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/tag_validation`, {
        params: {
          aroTag : _this.params.aroTag
        }
      });
    },
    apiIsShowDeliveryContents(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/contents/isShowDeliveryContents`, {
        params: {
          aroTag : _this.params.aroTag
        }
      });
    },
    apiAutoPaymentDate(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/autoPaymentDate`, {
        params: {}
      });
    },
    gaBasketList(){
      let _this = this;

      let refList = [];
      refList = _this.basket;
      let aroNo = "";
      if(_this.mode == Const.ARO_BASKET_MODE){
        //타입별
        aroNo = _this.aroApplyResult.aro_no;
      }else if(_this.mode == Const.ARO_15_BASKET_MODE){
        aroNo = _this.aroApplyResult.aro_no;
      }else{
        aroNo = _this.aroNtcApplyResult.ntcNo;
      }

      let retListValue = refList.map(item=>{
        return {
          name : item.pd_name_kr,
          id : item.pd_id,
          price : item.pd_amt1,
          brand : item.brand ? item.brand : '',
          category: item.category ? item.category : '',
          variant : 'ARO',
          quantity : item.pd_count
        };
      });

      let totalPrice = _this.total_price.payment_amt;
      let finalRetList = {};

      finalRetList = {
        actionField: {
          id: aroNo,
          revenue : totalPrice,
          shipping : 0
        },
        products : retListValue
      }

      return finalRetList;

    },
    getMemberInfo(){
      let _this = this;

      //NetFunnel : '장바구니' 화면에서 '정기구매 신청' 버튼 클릭시: act_12
      // NFStart({projectKey: 'service_1', segmentKey: 'act_12'}, function (response) {

        //show loading
        _this.$showLoading();
        _this.apiGetMmemberDetail().then(res=>{

          if (res.status === 200 && res.data.status === "000") {
            //주문 가능 회원 확인
            let result = _this.getAroSalesAuth(res.data);

            if(result === Const.MEMBER_HOLDER_TYPE_SUCCESS){
              _this.setDeliveryInfo(res.data);

              let birthDt = new Date(res.data.member.birth_dt);
              let month = '' + (birthDt.getMonth() + 1);
              let day = '' + birthDt.getDate();

              if (month.length < 2) month = '0' + month;
              if (day.length < 2) day = '0' + day;

              _this.memberBirthDt = month + "-" + day;

              _this.loadingData();
            }else if(result === Const.MEMBER_HOLDER_TYPE_SALESHOLDED){
              _this.$dialogs.alert(ErrMsg.COMM_SALES_HOLDER, {title: "결제하기"})
              .then(res => {
                _this.$router.push(`${_this.$aroBasePath}/basket`);
              });
            }else if(result === Const.MEMBER_HOLDER_TYPE_DIST_TEMP){
              _this.$dialogs.alert(ErrMsg.COMM_SALES_TYPE_DIST_TEMP, {title: "결제하기"})
              .then(res => {
                _this.$router.push(`${_this.$aroBasePath}/basket`);
              });
            }else{
              _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: "결제하기"})
              .then(res => {
                _this.$router.push(`${_this.$aroBasePath}/basket`);
              });
            }

            return _this.apiIsShowDeliveryContents();

          }else{
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
          }

        }).then(res=>{

          if (res.status === 200 && res.data.status === "0000") {
            if(res.data.result){
              _this.isShowContents = true;
              _this.contentsUrl = res.data.url;
              _this.contentMessage = res.data.message;
              _this.isShowDeliveryBtn = res.data.isShowDeliveryBtn;
              _this.btnTitle = res.data.btnTitle;
            }else{
              _this.isShowContents = false;
            }

            return _this.apiAutoPaymentDate();
          }else{
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {
              _this.isShowContents = false;
            });
          }
        }).then(res=>{

          if (res.status === 200 && res.data.status === "0000") {
            if(res.data.result){
              _this.paymentCase = res.data.case
            }else{
              _this.paymentCase = "1";
            }

            return;
          }else{
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {
              _this.isShowContents = false;
            });
          }
        }).catch((err)=>{
          console.error(err);
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          // NFStop();

          //hide loading
          _this.$hideLoading();
        });
      // });

      try{
        //_this.$refs.terms.setDeliveryDate('10', '3');
      }catch(e){
        //ignore
      }
    },
    getAroSalesAuth(data){
      let result = ""
      if(data){
        if(data.member.temporary){
          result = Const.MEMBER_HOLDER_TYPE_DIST_TEMP
        }else if(data.member.salesOrderHold){
          result = Const.MEMBER_HOLDER_TYPE_SALESHOLDED
        }else{
          result = Const.MEMBER_HOLDER_TYPE_SUCCESS
        }
      }

      return result;
    },
    setDeliveryInfo(data){
      let _this = this;


      let addressList = data.member.memberAddressList;
      if(addressList.length == 0){
        _this.shipInfoDialog.firstAddress = "배송주소가 없습니다. 배송정보 변경을 이용하여 신규 배송주소를 입력해 주세요."
        _this.shipInfoDialog.lastAddress = "";
        _this.shipInfoDialog.zipCode = "";
        _this.shipInfoDialog.address3 = "";
      }
      addressList.forEach((item)=>{
        if(item.own_typ === "OWN"){
          if(item.address3){
            _this.shipInfoDialog.firstAddress = `${item.address1} ${item.address2} ${item.address3}`;
            _this.shipInfoDialog.lastAddress = item.address4;
            _this.shipInfoDialog.zipCode = item.postal_cd;
            _this.shipInfoDialog.address3 = item.address3;
          }else{
            _this.shipInfoDialog.firstAddress = "배송주소가 없습니다. 배송정보 변경을 이용하여 신규 배송주소를 입력해 주세요."
            _this.shipInfoDialog.lastAddress = "";
            _this.shipInfoDialog.zipCode = "";
            _this.shipInfoDialog.address3 = item.address3;
          }
        }
      });

      _this.shipInfoDialog.shipName = _this.getMemberNmKr();
      _this.params.email = data.member.email;

      let memberPhoneList = data.member.memberPhoneList;
      memberPhoneList.forEach((item)=>{
        if(item.own_typ === "OWN" && item.phone_typ === "MB"){
           _this.shipInfoDialog.phoneNumber = item.phone_num;
        }
      });
    },
    loadingData(){
      let _this = this;

      _this.orderProductList();
    },
    orderProductList(){
      //주문내역
      let _this = this;

      _this.$refs.orderProductList.getData();
    },
    //Open dialog 배송 정보 변경
    openChangeShipInfoDialog(){
      let _this = this;

      //pass data to dialog
      _this.shipInfoDialog = {
        ..._this.shipInfoDialog,
        memberId : _this.getMemberId()
      };

      _this.$refs.shipInfoDialog.initData(_this.shipInfoDialog);
      _this.shipInfoDialogShow = true;
    },
    setTotalPrice(isOk, data){
      let _this = this;

       if(!isOk){
        //Do nothing
        return;
      }

      _this.total_price = {
        payment_amt: data.payment_amt,
        total_pv: data.total_pv,
        total_cv: data.total_cv,
        // total_sb: data.total_sb
      }

      _this.basket = data.basket;
    },
    //배송 정보 변경
    changeShipInfo(isOk, data){
      let _this = this;

      _this.shipInfoDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

       _this.shipInfoDialog = {...data};
       _this.shipInfoDialog.address3 = _this.shipInfoDialog.firstAddress;

    },
    validationPaymentData(){
      let _this = this;

      if(_this.mode != Const.ARO_NTC_BASKET_MODE && _this.shipInfoDialog.address3.trim() == ""){
         _this.$dialogs.alert("배송주소가 없습니다. 배송정보 변경을 이용하여 신규 배송주소를 입력해 주세요.", {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
        return false;
      }
      if(_this.shipInfoDialog === undefined || _this.shipInfoDialog.shipName === undefined ||
        _this.shipInfoDialog.shipName === null || _this.shipInfoDialog.shipName === "" ||
        _this.shipInfoDialog.phoneNumber === null || _this.shipInfoDialog.phoneNumber === "" ||
        _this.shipInfoDialog.zipCode === null || _this.shipInfoDialog.zipCode === "" ||
        _this.shipInfoDialog.firstAddress === null || _this.shipInfoDialog.firstAddress === "" ||
        _this.shipInfoDialog.lastAddress === null || _this.shipInfoDialog.lastAddress === ""){
        _this.$dialogs.alert("배송정보가 올바르지 않습니다. 배송정보 변경을 이용하여 신규 배송주소를 입력해 주세요.", {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
        return false;
      }
      if(_this.total_price.payment_amt <= 0){
          _this.$dialogs.alert("결제 정보가 올바르지 않습니다.", {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
            _this.$router.push(`${_this.$aroBasePath}/basket`);
          });
        return false;
      }

      if(!_this.checkTagValidation()){
        _this.$dialogs.alert("정기구매 주문 명칭은 특수문자를 사용 할 수 없습니다.", {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
        return false;
      }

      if(_this.params.aroTag != ""){
        if(_this.params.aroTag.length > 20){
          _this.$dialogs.alert("정기구매 주문 명칭은 최대 20자까지 입력하실 수 있습니다.", {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
          return false;
        }
      }

      //수령희망일 체크
      if(_this.mode === Const.ARO_BASKET_MODE || _this.mode === Const.ARO_15_BASKET_MODE){
        if(!_this.$refs.wishDelivery.validation()){
          return false;
        }
      }

      //결제수단 체크
      if(!_this.$refs.paymentMethod.validateInfo()){
        return false;
      }

      //약관 동의 체크
      if(!_this.$refs.terms.validation()){
        return false;
      }

      //NetFunnel : 결제하기' 화면에서 '결제하기' 버튼 클릭시: act_16
      NFStart({projectKey: 'service_1', segmentKey: 'act_16'}, function (response) {
        let paymentInfo = _this.$refs.paymentMethod.getData();
        if(paymentInfo.paymentType == "2"){
          //신용카드

          _this.$refs.paymentMethod.reqCheckCard().then(isCardValid=>{
            if(!isCardValid){
              NFStop();
              return false;
            }

            _this.setAroApplyData();

            //GA 전송-주문내역 결제하기 클릭
            try{
              _this.sendGaAroPayment("신용카드");
            }catch(e){
              //ignore
              console.error(e);
            }

            if(_this.mode != Const.ARO_NTC_BASKET_MODE){
              _this.goAroApply();
            }else{
              _this.goNtcApply();
            }

          });
        }else{
          //계좌이체
          _this.setAroApplyData();

          //GA 전송-주문내역 결제하기 클릭
          try{
            _this.sendGaAroPayment("계좌이체");
          }catch(e){
            //ignore
            console.error(e);
          }

          _this.goAroApply();
        }
      });

    },
    //결제정보
    setAroApplyData(){
      let _this = this;
      let paramResult = {};

      paramResult.payment_amt = _this.total_price.payment_amt;
      paramResult.e_transaction_type = _this.$refs.ElectronicStatement.getData();
      if(_this.mode != Const.ARO_NTC_BASKET_MODE){
        paramResult.delivery_day = _this.$refs.wishDelivery.getData();
        paramResult.ship_name = _this.shipInfoDialog.shipName;
        paramResult.ship_tel = _this.shipInfoDialog.phoneNumber;
        paramResult.ship_phone = _this.shipInfoDialog.phoneNumber;
        paramResult.postal_cd = _this.shipInfoDialog.zipCode;
        paramResult.home_addr = _this.shipInfoDialog.firstAddress;
        paramResult.home_addr_detail = _this.shipInfoDialog.lastAddress;
        paramResult.wholesale_receipt = _this.$refs.receipt.getData();
        if(_this.mode == Const.ARO_15_BASKET_MODE){
          paramResult.uspan_yn = _this.uspan_yn;
          paramResult.uspancode = _this.uspancode;
        }
      }else{
        paramResult.payment_day = _this.$refs.wishPayment.getData();
        paramResult.email = _this.params.email;
        paramResult.homeNumber = _this.shipInfoDialog.phoneNumber;
        paramResult.mobile_phone_num = _this.shipInfoDialog.phoneNumber;
      }
      paramResult.member_name = _this.getMemberNmKr();

      let data = _this.$refs.paymentMethod.getData();
      paramResult.payment_typ = data.paymentType;
      if(data.paymentType == 2){
        paramResult.ccard_no = data.card.cardNums[0]+data.card.cardNums[1]+data.card.cardNums[2]+data.card.cardNums[3];
        paramResult.ccard_exp = data.card.expYY + data.card.expMM;
        paramResult.passwd = data.card.pwd;
        paramResult.inst_month = data.card.instMonth;
        paramResult.birth_dt = data.card.birth;
      }else{
        paramResult.cms_no = data.account.cms_no;
        paramResult.receipt_no = data.account.receipt_no;
        paramResult.birth_dt = data.account.birth;
      }
      paramResult.aroTag = _this.params.aroTag;
      _this.params = {...paramResult};
    },
    //ARO, 15ARO 신청
    goAroApply(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiOrderAro().then(res=>{

        if (res.status === 200 && res.data.status === Const.ARO_DATA_API_SUCCESS) {
          _this.aroApplyResult = {...res.data};
          _this.showAroResult = true;
          //장바구니 변경 handler
          _this.$changeBasketCount();

          //GA 전송-주문내역 배송정보버튼 클릭
          try{
            var products = _this.gaBasketList();
            _this.sendGaAroPurchase(products);
          }catch(e){
            //ignore
            console.error(e);
          }

          //최상단 스크롤 이동
          window.scrollTo( 0, 0);
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        NFStop();

        //hide loading
        _this.$hideLoading();
      });
    },
    goNtcApply(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiOrderNtc().then(res=>{

        if (res.status === 200 && res.data.status === Const.ARO_DATA_API_SUCCESS) {
          return _this.apiGetNtc();

        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }
        return null;
      }).then(ntcRes => {
        if(ntcRes){

          if (ntcRes.status === 200 && ntcRes.data.status === Const.ARO_DATA_API_SUCCESS) {
            _this.aroNtcApplyResult = {...ntcRes.data};
            _this.showAroResult = true;
            //장바구니 변경 handler
            _this.$changeBasketCount();

            //GA 전송-주문내역 배송정보버튼 클릭
            try{
              var products = _this.gaBasketList();
              _this.sendGaAroPurchase(products);
            }catch(e){
              //ignore
              console.error(e);
            }

            //최상단 스크롤 이동
            window.scrollTo( 0, 0);
          }else{
            _this.$dialogs.alert(ntcRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
          }
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        NFStop();

        //hide loading
         _this.$hideLoading();
      });
    },
    getPaymentData(isOk, data){
      let _this = this;

      if(!isOk){
        //Do nothing
        return;
      }

       if(data.payment_typ === "2"){
        //카드 결제
        _this.params.ccard_no = data.card.ccard_no;
        _this.params.ccard_exp = data.card.ccard_exp;
        _this.params.passwd = data.card.passwd;
        _this.params.inst_month = data.card.inst_month;
        _this.params.birth_dt = data.card.birth;
      }else{
        _this.params.cms_no = data.account.cms_no;
        _this.params.receipt_no = data.account.receipt_no;
        _this.params.birth_dt = data.account.birth;
      }
    },
    setTerms(isOk, data){
      let _this = this;
      if(!isOk){
        //_this.$refs.terms.setCardTerms(false);
        return;
      }

      if(data == "2"){
        _this.$refs.terms.setCardTerms(true);
      }else{
        _this.$refs.terms.setCardTerms(false);
      }
    },
    checkTagValidation(){
      let _this = this;
      let aroTag = _this.params.aroTag;

      if(aroTag != ""){
        var check_pattern = /^[0-9A-Za-z가-힣ㄱ-ㅎ-ㅏ-ㅣ\-./,\s]*$/g;

        if((check_pattern.test(aroTag))){
          return true;
        }else{
          return false;
        }
      }

      return true;
    },

    onChangeWishDeliveryDate(deliveryDay){
      let _this = this;

      try{
        //_this.$refs.terms.setDeliveryDate(`${deliveryDay}`, `${deliveryDay - 7}`);
      }catch(e){
        //ignore
      }
    },
    //GA 전송-결제완료
    sendGaAroPurchase(orderProductList){
      let _this = this;

      let gaData = {
        event: 'purchase_ARO',
        ecommerce: {
          purchase: orderProductList
        }
      };
      _this.$sendAroGA(gaData);
    },
    //GA 전송-결제완료
    sendGaAroPayment(paymentType){
      let _this = this;

      let gaData = {
        event: 'checkoutOption_ARO',
        ecommerce: {
        checkout_option: {
          actionField: {step: 1, option: paymentType}
       }
    }

      };
      _this.$sendAroGA(gaData);
    }
  }
};
</script>
<style>
a.delivery, a.goPay{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/product/payment.vue